/** @format */

import './gb-edit-team-scoring-dialog.scss';

export class GbEditTeamScoringDialogController {
    constructor($mdDialog, widget, auction, $gbTeam, $log) {
        'ngInject';

        this.$mdDialog = $mdDialog;
        this.widget = widget;
        this.auction = auction;
        this.$gbTeam = $gbTeam;
        this.$log = $log;

        this.order = 'order';
        this.page = 1;
        this.limit = 20;
        this.search = null;
        this.teams = [];

        this.debounceTime = 500;

        this.hiddenTeams = [];

        this.allTeamsSelected = false;
    }

    $onInit() {
        this.syncTeams();
        this.hiddenTeams = this.widget.hidden_teams;
    }

    addAllTeams() {
        for (let i = 0; i < this.teams.length; i++) {
            let team = this.teams[i];
            if (this.hiddenTeams.indexOf(team.uuid) === -1) {
                this.hiddenTeams.push(team.uuid);
            }
        }
    }

    removeAllTeams() {
        for (let i = 0; i < this.teams.length; i++) {
            const team = this.teams[i];
            const index = this.hiddenTeams.indexOf(team.uuid);
            if (index > -1) {
                this.hiddenTeams.splice(index, 1);
            }
        }
    }

    toggleSelectAll() {
        this.allTeamsSelected = !this.allTeamsSelected;
        if (this.allTeamsSelected) {
            this.addAllTeams();
        } else {
            this.removeAllTeams();
        }
    }

    toggleSelectTeam(team) {
        let index = this.hiddenTeams.indexOf(team.uuid);
        if (index === -1) {
            this.hiddenTeams.push(team.uuid);
        } else {
            this.hiddenTeams.splice(index, 1);
        }
    }

    isHidden(team) {
        return this.hiddenTeams.indexOf(team.uuid) === -1;
    }

    onSubmit() {
        return this.$mdDialog.hide(this.hiddenTeams);
    }

    onCancel() {
        return this.$mdDialog.cancel();
    }

    getSyncParams() {
        return {
            auction: this.auction,
            limit: this.limit,
            offset: this.offset,
            search: this.search,
            ordering: this.order,
        };
    }

    syncTeams() {
        return this.$gbTeam.query(this.getSyncParams()).$promise.then((data) => {
            this.$log.info('Synced Teams', data);
            this.$gbTeam.cache.push(data);
            this.teams = data;

            // only update total if no search param
            if (!this.search) {
                this.teamsTotal = data._total;
            }
            return data;
        });
    }
}
